import React from 'react';
import { Flex, Text, Alert, Button } from '@mantine/core';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import colorsCustom from '../../designTokens/colorsCustom';

export const DataLoadError = ({ 
  title, 
  message, 
  onRetry, 
  isMobile = false,
  showRetry = false 
}) => {
  const { t } = useTranslation();
  
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap={16}
      p={isMobile ? 32 : 48}
      w="100%"
      style={{
        backgroundColor: colorsCustom.paper,
        borderRadius: 16,
        border: `1px solid #ffa94d20`,
        minHeight: isMobile ? 200 : 240
      }}
    >
      <IconAlertTriangle size={isMobile ? 32 : 40} color="red" />
      <Flex direction="column" align="center" gap={8}>
        <Text 
          size={isMobile ? 'md' : 'lg'} 
          fw={600} 
          ta="center"
          c="gray.8"
        >
          {title || t('error.dataLoadFailed')}
        </Text>
        <Text 
          size={isMobile ? 'sm' : 'md'} 
          c="gray.6" 
          ta="center"
          maw={300}
        >
          {message || t('error.threadsDataLoadFailed')}
        </Text>
      </Flex>
      {showRetry && onRetry && (
        <Button
          variant="light"
          color="orange"
          size={isMobile ? 'sm' : 'md'}
          leftSection={<IconRefresh size="1rem" />}
          onClick={onRetry}
        >
          {t('common.retry')}
        </Button>
      )}
    </Flex>
  );
}; 